/**
 * Cross-component event names for the Chief complaints section. Kept in a
 * standalone module (no default export, no hooks) so imports don't accidentally
 * pull in the ChiefComplaints component and hit CRA-3 module-init timing edge
 * cases on first render.
 */
export const CC_V2_REFRESH = "cc-v2:refresh";

// Content -> editor rail: open a blank "Add complaint" form.
export const CC_V2_ADD = "cc-v2:add";

// Content -> editor rail: open the "Update status" form prefilled with a
// complaint. Payload is { complaint }. This used to be a centred dialog
// (UpdateStatusModal); the rail now owns both halves of the section's write
// surface, same contract as the lab-investigations rail.
export const CC_V2_EDIT = "cc-v2:edit";

// Transcript-mode re-edit of an already-staged captured item. Fired when
// the care manager clicks a status chip on a peach-highlighted row
// during a live call. Payload is { captured, ccv2Record } — the
// captured is the transcript.captured[] entry to modify in place;
// ccv2Record is the underlying CC v2 complaint (only present when the
// captured is operation="update"). Handled by CapturedSections; the
// sidebar-mounted editor rail ignores this event.
export const CC_V2_EDIT_CAPTURED = "cc-v2:edit-captured";
